import React from "react";
import Styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

import googleIcon from '../../../../theme/assets/svg/b_cabinet_profile_2fa_google_icon.svg';
import noteIcon from '../../../../theme/assets/svg/b_cabinet_profile_2fa_note_icon.svg';

const MethodStep = ({
                        providers = [],
                        selectedMethod,
                        onSelectMethod,
                        onCancel,
                        onContinue,
                        isLoading = false,
                    }) => {
    const { t } = useTranslation();

    const hasProviders = providers.length > 0;

    return (
        <div className={Styles.methodStep}>
            <div className={Styles.sectionTitle}>
                {t("Выберите метод аутентификации")}
            </div>

            {hasProviders ? (
                <div className={Styles.methodsList}>
                    {providers.map((provider) => {
                        const isActive = selectedMethod === provider.value;

                        return (
                            <button
                                type="button"
                                className={`
                                    ${Styles.methodCard}
                                    ${isActive ? Styles.methodCardActive : ""}
                                `}
                                key={provider.value}
                                onClick={() => onSelectMethod(provider.value)}
                                disabled={isLoading}
                            >
                                <div className={Styles.methodIcon}>
                                    <img src={googleIcon} alt="Google Authentification"/>
                                </div>

                                <div className={Styles.methodTextWrap}>
                                    <div className={Styles.methodTitle}>
                                        {provider.label}
                                    </div>

                                    <div className={Styles.methodText}>
                                        {t("Используйте приложение-аутентификатор для генерации 6-значных кодов безопасности.")}
                                    </div>
                                </div>

                                <div className={Styles.radioCircle}>
                                    {isActive && <span />}
                                </div>
                            </button>
                        );
                    })}
                </div>
            ) : (
                <div className={Styles.emptyProviders}>
                    {t("Доступные методы аутентификации не найдены")}
                </div>
            )}

            <div className={Styles.infoNotice}>
                <div className={Styles.noticeIcon}>
                    <img src={noteIcon} alt="note"/>
                </div>

                <div className={Styles.noticeText}>
                    {t("Далее вы отсканируете QR-код и подтвердите вход 6-значным кодом.")}
                </div>
            </div>

            <div className={Styles.actionsRow}>
                <button
                    type="button"
                    className={Styles.cancelBtn}
                    onClick={onCancel}
                    disabled={isLoading}
                >
                    {t("Отмена")}
                </button>

                <button
                    type="button"
                    className={Styles.continueBtn}
                    onClick={onContinue}
                    disabled={!selectedMethod || isLoading}
                >
                    {isLoading ? t("Загрузка") : t("Продолжить")}
                </button>
            </div>

            <div className={Styles.bottomNote}>
                {t("Двухфакторная аутентификация помогает защитить ваш аккаунт.")}
            </div>
        </div>
    );
};

export default MethodStep;